import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";
import { API_BASE_URL, API_BASE_URL3 } from "../../../Services/baseApiUrl";

const getToken = () => {
    return localStorage.getItem("token");
};


export const GetPrimaryVehicleDeploymentReport = async (payload) => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}RawReport/PrimaryVehicleDeploymentReport`,
            {
                params: {
                    WardId:
                        payload?.wardId !== null &&
                        payload?.wardId !== undefined &&
                        payload?.wardId !== ""
                            ? payload.wardId
                            : undefined,

                    fromDate:
                        payload?.fromDate || undefined,

                    toDate:
                        payload?.toDate || undefined,
                },
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                },
            }
        );

        return response;
    } catch (error) {
        throw error;
    }
};

export const GetVehicleTripSummary = async (payload) => {
    try {
        const formData = new FormData();

        if (payload?.fromDate) formData.append("FromDate", payload.fromDate);
        if (payload?.toDate) formData.append("ToDate", payload.toDate);
        if (payload?.vehicleTypeId) formData.append("VehicleTypeId", payload.vehicleTypeId);
        if (payload?.transferStationId) formData.append("TransferStationId", payload.transferStationId);

        const response = await axiosInstance.post(`${API_BASE_URL1}RawReport/vehicle-trip-summary`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response;
    } catch (error) {
        return error;
    }
};

export const GetVehicleTypesList = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}RawReport/vehicle-types`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }

    
};

export const GetTransferStationsList = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}RawReport/transfer-stations`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }

};



export const HookLoaderReport = async (payload = {}) => {
    try {
        const formData = new FormData();

        if (payload.circleId) {
            formData.append("CircleId", payload.circleId);
        }

        if (payload.vehicleNo) {
            formData.append("VehicleNumber", payload.vehicleNo);
        }

        
if (payload.fromDate) {
    formData.append("FromDate", payload.fromDate);
}

if (payload.toDate) {
    formData.append("ToDate", payload.toDate);
}



        const response = await axiosInstance.post(
            `${API_BASE_URL1}RawReport/hook-loader-vehicle-summary`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response;

    } catch (error) {
        throw error;
    }
};


export const HookLoaderVehicleInnerReport = async (params = {}) => {
  const formData = new FormData();

  if (params.vehicleNumber) {
    formData.append("VehicleNumber", params.vehicleNumber);
  }

  if (params.wardId) {
    formData.append("WardId", params.wardId);
  }

  if (params.fctsId) {
    formData.append("FctsId", params.fctsId);
  }

  if (params.dumpsiteId) {
    formData.append("DumpsiteId", params.dumpsiteId);
  }

  if (params.fromDateTime) {
    formData.append("FromDateTime", params.fromDateTime);
  }

  if (params.toDateTime) {
    formData.append("ToDateTime", params.toDateTime);
  }

  return axiosInstance.post(
    `${API_BASE_URL1}RawReport/hook-loader-vehicle-inner-report`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

export const GetAllCircles = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL}V1/Complaint/Master/GetAllCircles`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const GetMasterCircles = async () => {
    try {
        const response = await axiosInstance.get(
            `${API_BASE_URL1}MasterDetails/GetAllCircles?pageNumber=1&pageSize=100`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const SecondaryCollectionPoint = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL1}RawReport/secondary-collection/overview`,
    {
      params: {
        fromDate: params.fromDate || undefined,
        toDate: params.toDate || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};


export const SecondaryCollectionPointInner = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL1}RawReport/secondary-collection/inner`,
    {
      params: {
        CircleId: params.circleId || undefined,
        CollectionPointTypeId:
          params.collectionPointTypeId || undefined,
        FromDate: params.fromDate || undefined,
        ToDate: params.toDate || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetCollectionPoint = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL1}RawReport/getCollectionPoint`,
    {
      params: {
        fromDate: params.fromDate || undefined,
        toDate: params.toDate || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};


export const RcDeployeVehicleInner = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL1}RawReport/RcDeployeinner-report`,
    {
      params: {
        vehicleNumber: params.vehicleNumber || undefined,
        site: params.site || undefined,
        fromDateTime: params.fromDateTime || undefined,
        toDateTime: params.toDateTime || undefined,
        circleId: params.circleId || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetTransferStations = async () => {
  return axiosInstance.get(`${API_BASE_URL1}RawReport/transfer-stations`, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
};

export const RcDeployeVehicleSummary = async (params = {}) => {
  const today = getTodayDate();

  return axiosInstance.get(
    `${API_BASE_URL1}RawReport/RcDeploymentvehicle-summary`,
    {
      params: {
        circleId: params.circleId || undefined,
        fromDate: params.fromDate || today,
        toDate: params.toDate || today,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const getTodayDate = () => {
  const today = new Date();

  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const GetWardCoverageReport = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL3}Routes/GetReport`,
    {
      params: {
        WardId: params.wardId || undefined,
        fromDate: params.fromDateTime || undefined,
        toDate: params.toDateTime || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetVehicleDetailsReport = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL3}Routes/GetVehicleDetails`,
    {
      params: {
        WardId: params.wardId || undefined,
        vehicleNo: params.vehicleNo || undefined,
        fromDate: params.fromDateTime || undefined,
        toDate: params.toDateTime || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetVehicleHaltPointDetails = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL3}Routes/circle-vehicle-halt-point-details`,
    {
      params: {
        circleId: params.circleId || params.wardId || undefined,
        vehicleId: params.vehicleId || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetVehicleHaltPointBalanceDetails = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL3}Routes/circle-vehicle-halt-point-balance-details`,
    {
      params: {
        circleId: params.circleId || params.wardId || undefined,
        vehicleId: params.vehicleId || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const ClearVehicleHaltPoint = async (formData) => {
  return axiosInstance.post(
    `${API_BASE_URL3}Routes/clear-vehicle-halt-point`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};

export const GetVehicleHaltPointViewDetails = async (params = {}) => {
  return axiosInstance.get(
    `${API_BASE_URL3}Routes/circle-vehicle-halt-point-view-details`,
    {
      params: {
        circleId: params.circleId || params.wardId || undefined,
        vehicleId: params.vehicleId || undefined,
        stoppageId: params.stoppageId || undefined,
      },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    }
  );
};